import {
  Input,
  Button,
  Space,
  DatePicker,
  Col,
  Row,
  Form,
  Tooltip,
} from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  ALPHABETS_REGEX,
  APPID,
  BANKDETILSBYIFSC,
  DATE_FORMAT,
  GUTTOR_SPACE,
  IFSC_REGEX,
  NAME_REGEX,
  NAME_WITH_SPECIAL_CHARS,
  NUMBER_REGEX,
  PANCARD_REGEX,
  REQUEST_PAYLOAD,
  SAVEREGISTRATIONPANANDBANKDETAILS,
  TOOLTIP_TEXT,
} from '../../../../../shared/constants/commonConstants';
import SendRequest from '../../../../../shared/services/sendRequest.service';
import { fetchHospitalProfile } from '../../../../../store/actions/hospitalAction';
import {
  BankDetail,
  PANDetail,
  RegistrationDetail,
  SaveRegistrationPANAndBankDetailsRequest,
  SaveRegistrationPANAndBankDetailsResponse,
} from '../../../../../store/models/accountdetailModel';
import { error, GetFirstElement, success } from '../../../../../utils/utility';
import { ReactComponent as EditIcon } from '../../../../../assets/images/svg/i_edit.svg';
import './SaveAccountDetail.less';

const SaveAccountDetail = ({ data, onCancel }: any): any => {
  const dispatch = useDispatch();
  const [isAPICall, setIsAPICall] = useState(false);
  const [dateCheck, setDateCheck] = useState(false);
  const [isPanEnabled, setIsPanEnabled] = useState(false);
  const [isAccountNumberEnabled, setIsAccountNumberEnabled] = useState(false);
  const [form] = Form.useForm();
  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const validate = {
    // eslint-disable-next-line
    required: '${label} is required!',
  };

  useEffect((): void => {
    if (data) {
      const [bankData]: BankDetail[] = data?.bankDetails || [];
      const [registrationData]: RegistrationDetail[] =
        data?.registrationDetails || [];
      form.setFieldsValue({
        panCard: data.panCardNumber,
        panCardName: data.panCardHolderName,
      });
      if (registrationData) {
        form.setFieldsValue({
          registrationNumber: registrationData.registrationNumber,
          registrationAuthority: registrationData.registrationAuthority,
          startDate: registrationData.registrationStartDate,
          endDate: registrationData.registrationEndDate,
        });
      }
      if (bankData) {
        form.setFieldsValue({
          accountName: bankData.accountHolderName,
          accountNumber: bankData.accountNumber,
          ifscCode: bankData.ifscCode,
          bankName: bankData.bankName,
          bankAddress: bankData.bankAddress,
        });
      }
      form.setFieldsValue({
        rohiniId: ((data?.rohiniId && data?.rohiniId?.trim()) && data?.rohiniId !== '0') ? data?.rohiniId : undefined,
      });
    }
    // eslint-disable-next-line
  }, []);

  const saveRegistrationPANAndBankDetail = async (payload: any): Promise<any> => {
    const url = process.env.REACT_APP_BASE_URL + SAVEREGISTRATIONPANANDBANKDETAILS;
    const result: any = await SendRequest.instance.post<
      SaveRegistrationPANAndBankDetailsRequest,
      SaveRegistrationPANAndBankDetailsResponse
    >(url, payload);
    setIsAPICall(!isAPICall);
    if (result && result.isSuccess) {
      dispatch(fetchHospitalProfile(REQUEST_PAYLOAD));
      success('Successfully submitted');
    } else {
      error('Please try again');
    }
  };

  const fetchDetailByIFSCCode = async (ifscCode: any): Promise<any> => {
    const url = process.env.REACT_APP_BASE_URL + BANKDETILSBYIFSC + ifscCode;
    return await SendRequest.instance.get<any>(url);
  };

  const onSearchIFSC = (event: any): void => {
    form.setFieldsValue({
      bankName: '',
      bankAddress: '',
    });
    if (
      event.target &&
      event.target.value &&
      IFSC_REGEX.test(event.target.value)
    ) {
      fetchDetailByIFSCCode(event.target.value).then((resp: any): void => {
        if (resp && resp.isSuccess) {
          form.setFieldsValue({
            ifscCode: resp.ifsc,
            bankName: resp.bank,
            bankAddress: resp.address,
          });
        }
      });
    }
  };

  const onStarDate = (date: any, dateString: any): void => {
    if (dateString) {
      form.setFieldsValue({
        startDate: dateString,
      });
      setDateCheck(true);
    }
  };
  const onEndDate = (date: any, dateString: any): any => {
    if (dateString) {
      form.setFieldsValue({
        endDate: dateString,
      });
      setDateCheck(false);
    }
  };
  const onSubmit = (event: any): any => {
    const bankdetailreq: any = [];
    const [bankDetail]: BankDetail[] = data?.bankDetails || [];
    const registrationreq: any = [];
    const saveData: any = form.getFieldsValue();
    const bankdetailobject: BankDetail = {
      profileId: data.id,
      accountNumber: saveData.accountNumber,
      accountHolderName: saveData.accountName,
      ifscCode: saveData.ifscCode,
      bankName: saveData.bankName,
      bankAddress: saveData.bankAddress,
      isActive: true,
      id: bankDetail?.id || 0,
    };
    bankdetailreq.push(bankdetailobject);
    const regData = data.registrationDetails?.filter((x: any): any => x.typeName?.toLowerCase() === 'hospital');
    const registrationDetailObject: RegistrationDetail = {
      profileId: data.id,
      typeName: 'Hospital',
      registrationNumber: saveData.registrationNumber,
      registrationAuthority: saveData.registrationAuthority,
      registrationStartDate: saveData.startDate,
      registrationEndDate: saveData.endDate,
      isActive: true,
      id: regData.length > 0 ? regData[0].id : 0,
    };
    registrationreq.push(registrationDetailObject);

    const panDetailObj: PANDetail = {
      name: saveData.panCardName,
      number: saveData.panCard,
    };
    const reqpayload: SaveRegistrationPANAndBankDetailsRequest = {
      applicationId: APPID,
      profileId: data.id,
      rohiniId: saveData?.rohiniId ? saveData?.rohiniId : undefined,
      bankDetails: bankdetailreq,
      registrationDetails: registrationreq,
      panDetail: panDetailObj,
    };
    saveRegistrationPANAndBankDetail(reqpayload);
  };

  const onAccountNumberEdit = (): void => {
    setIsAccountNumberEnabled(true);
    form.setFieldsValue({
      accountName: '',
      accountNumber: '',
      ifscCode: '',
      bankName: '',
      bankAddress: '',
    });
  };

  const onPanCardEdit = (): void => {
    setIsPanEnabled(true);
    form.setFieldsValue({
      panCard: '',
      panCardName: '',
    });
  };

  const onCancelHandle = (): any => {
    onCancel();
  };
  const disabledDate = (current: any): any => {
    const date = form.getFieldsValue(['startDate']).startDate;
      return current < moment(date).endOf('day');
  };
  // If start date field changes the end date field gets reset else normal flow
  const changeEndDate = (): moment.Moment | undefined | any => {
    if (dateCheck) {
      form.resetFields(['endDate']);
    } else {
      const registrationEndDate = GetFirstElement(data?.registrationDetails)?.registrationEndDate;
      return registrationEndDate ? moment(new Date(registrationEndDate), DATE_FORMAT) : undefined;
    }
  };
  return (
    <>
      {!isAPICall && (
        <Form
          form={form}
          {...layout}
          name="nest-messages"
          validateMessages={validate}
          onFinish={onSubmit}
        >
          <Row gutter={GUTTOR_SPACE}>
            <Col md={12}>
              <Form.Item
                name="registrationNumber"
                label="Registration No."
                rules={[
                  {
                    required: true,
                    max: 30,
                    pattern: NAME_WITH_SPECIAL_CHARS,
                    message: 'Please enter valid registration number',
                  },
                ]}
              >
                <Input
                  placeholder="Please enter registration No."
                  className="text-capital"
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="registrationAuthority"
                label="Registration authority"
                rules={[
                  {
                    required: true,
                    pattern: NAME_REGEX,
                    message: 'Please enter valid registration authority',
                  },
                ]}
              >
                <Input
                  placeholder="Please enter registration authority"
                  className="text-capitalize"
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="startDate"
                label="Start date"
                rules={[{ required: true }]}
              >
                <Space direction="vertical" className="w-100">
                  <DatePicker
                    className="w-100"
                    allowClear={false}
                    dropdownClassName="save-account-detail"
                    inputReadOnly={true}
                    onChange={(date: any, dateString: string): void =>
                      onStarDate(date, dateString)
                    }
                    defaultValue={
                      GetFirstElement(data?.registrationDetails)?.registrationStartDate
                      ? moment(new Date(GetFirstElement(data?.registrationDetails)?.registrationStartDate), DATE_FORMAT)
                        : undefined
                    }
                  />
                </Space>
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="endDate"
                label="End date"
                rules={[{ required: true }]}
              >
                <Space direction="vertical" className="w-100">
                  <DatePicker
                    className="w-100"
                    allowClear={false}
                    dropdownClassName="save-account-detail"
                    inputReadOnly={true}
                    onChange={(date: any, dateString: string): void =>
                      onEndDate(date, dateString)
                    }
                    defaultValue={changeEndDate()}
                    disabledDate={(e: any): any => disabledDate(e)}
                    />
                </Space>
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="rohiniId"
                label="Rohini ID"
                rules={[{ required: false }]}
              >
                <Input
                  style={{ width: '100%' }}
                  placeholder="Please enter Rohini ID"
                  maxLength={15}
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="panCard"
                label="PAN card No."
                rules={[
                  { required: true },
                  {
                    pattern: !isPanEnabled ? undefined : PANCARD_REGEX,
                    message: 'Please type valid PAN',
                  },
                ]}
              >
                <Input
                  placeholder="Please enter PAN card No."
                  className="text-capital"
                  readOnly={!isPanEnabled}
                  suffix={
                    <Tooltip title={TOOLTIP_TEXT.edit}>
                      <EditIcon onClick={onPanCardEdit} className="mouse-pointer fill-primary" />
                    </Tooltip>}
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="panCardName"
                label="Name on PAN card"
                rules={[
                  { required: true },
                  {
                    pattern: NAME_REGEX,
                    message: 'Please type alphabets only',
                  },
                ]}
              >
                <Input
                  placeholder="Please enter name on PAN card"
                  className="text-capitalize"
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="accountNumber"
                label="Account No."
                rules={[
                  {
                    required: true,
                    pattern: !isAccountNumberEnabled ? undefined : NUMBER_REGEX,
                    message: 'Please type valid account no.',
                  },
                ]}
              >
                <Input maxLength={20}
                  readOnly={!isAccountNumberEnabled}
                  suffix={
                    <Tooltip title={TOOLTIP_TEXT.edit}>
                      <EditIcon onClick={onAccountNumberEdit} className="mouse-pointer fill-primary" />
                    </Tooltip>
                  }
                  placeholder="Please enter account No."
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="accountName"
                label="Account holder name"
                rules={[
                  {
                    required: true,
                    pattern: ALPHABETS_REGEX,
                    message: 'Please enter valid account holder name',
                  },
                ]}
              >
                <Input
                  placeholder="Please enter account holder name"
                  className="text-capitalize"
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="ifscCode"
                label="IFSC code"
                rules={[
                  { required: true },
                  {
                    pattern: IFSC_REGEX,
                    message: 'Please type valid ifsc',
                  },
                ]}
              >
                <Input
                  className="text-capital"
                  placeholder="Please enter IFSC code"
                  onChange={(value: any): any => onSearchIFSC(value)}
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                label="Bank name"
                name="bankName"
                rules={[{ required: true }]}
              >
                <Input placeholder="Bank name" disabled={true} />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                label="Bank address"
                name="bankAddress"
                rules={[{ required: true }]}
              >
                <Input placeholder="Bank address" disabled={true} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE}>
            <Col md={24} className="text-right">
              <Button onClick={onCancelHandle} className="btn-cancel">
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
};
export default SaveAccountDetail;
